import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ILocation } from '@ess-front/shared';
import { SelfExploreMapService } from '@domain/self-explore-map.service';
import { MatDialog } from '@angular/material/dialog';
import { SelfExploreModalComponent } from '@features/experience/components/self-explore-modal/self-explore-modal.component';
import { environment } from '@environment';

@Component({
  selector: 'ess-experience-self-explore-mobile',
  templateUrl: './experience-self-explore-mobile.component.html',
  styleUrls: ['./experience-self-explore-mobile.component.scss'],
  providers: [SelfExploreMapService],
  standalone: false,
})
export class ExperienceSelfExploreMobileComponent implements AfterViewInit {
  @Input() relatedExperiences: ILocation[] = [];
  @ViewChild('map') mapEl: ElementRef | null = null;
  public readonly NUMBER_URL = environment.cloudinaryURL + 'v1654236851/experience/icons/markers/number-outline-';

  constructor(
    private selfExploreMapService: SelfExploreMapService,
    public dialog: MatDialog,
  ) {}

  async ngAfterViewInit() {
    await this.initializeMap();
  }

  private async initializeMap() {
    await this.selfExploreMapService.createMap(this.mapEl?.nativeElement, this.relatedExperiences, true);
    await this.selfExploreMapService.offsetMapBottom(100);
  }

  openSelfExploreModal() {
    this.dialog.open(SelfExploreModalComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      width: '100vw',
      data: { relatedExperiences: this.relatedExperiences },
    });
  }
}
